import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router/index'
import { message } from '../axios/message';
import request from "../axios/request";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    addForm: {
      contact: null,
      sex: null,
      phoneNumber: null,
      location: null,
      detailAddress: null,
      type: null,
      lng: null,
      lat: null
    },
    typeName: null,
    selectedAddress: null,
    indexBarHeight: 50,
    navigateUrl: null,
    wsId: null,
    socket: null,
    roomId: null,
    messageRooms: new Map(),
    messageList: [],
    currentRoomId: null,
    showMessageDialog: null,
    messageDialogContent: null,
    dialogMessageType:null
  },
  getters: {

  },
  mutations: {
    clearMessageList(state) {
      state.messageList = []
      state.currentRoomId = null
    },
    setCurrentRoomId(state, roomId) {
      state.currentRoomId = roomId
    },
    setTypeName(state, typeName) {
      state.typeName = typeName
    },
    sendMessage(state, payload) {
      state.socket.send(payload)
    },
    initWs(state, payload) {
      let wsId = payload.wsId
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        // let wsUrl = window.location.origin.replace("http://", "");
        // // 实例化socket 111是固定的用户id,正式环境直接获取当前登录用户id
        // state.socket = new WebSocket(
        //   "ws:" + "127.0.0.1:8094" + "//wsServer/" + wsId
        // );

        let wsUrl = window.location.origin.replace("https://", "");
        state.socket = new WebSocket(
          "wss:" + wsUrl+ "//wsServer/" + wsId
        );
        console.log("开始连接ws");
        console.log("ws:" + wsUrl + "//wsServer/" + wsId);
        this.$global.setWs(state.socket);

        // 监听socket连接
        state.socket.onopen = () => {
          console.log("socket连接成功");
          state.socket.send(JSON.stringify(payload));
        };
        // 监听socket错误信息
        state.socket.onerror = () => {
          console.error("连接错误");

        };
        //监听socket消息
        state.socket.onmessage = async (msg) => {
          let jsonObject = JSON.parse(msg.data).data;
          if (jsonObject.type == "initReply") {
            if (jsonObject.ResultCode == "401") {
              message.error(jsonObject.desc)
              router.push(jsonObject.url)
            }
            state.roomId = jsonObject.roomId


          } else if (jsonObject.type == "messageAck") {
            console.log("消息已由服务器保存", jsonObject.messageId)
          } else if (jsonObject.type == "error") {
            message.error(jsonObject.desc || "消息发送失败")
          } else if (jsonObject.type == "mes") {
            const senderType = jsonObject.data.senderType
            const senderId = jsonObject.data.senderId
            const roomId = jsonObject.data.roomId
            const content = jsonObject.data.content
            const sendTime = jsonObject.data.sendTime
            let roomName = null
            switch (senderType) {
              case 0:
                roomName = "用户" + senderId
                break;
              case 1:
                roomName = "客服" + senderId
                break;
              case 3:
                roomName = "骑手" + senderId
                break;
              default:
                break;
            }
            const newMap = new Map(state.messageRooms);

            let roomIcon = null
            if (!newMap.has(roomId)) {
              if (senderType == 2) {
                let res = await request({
                  url: "/company/api/getCompanySimpleInfo?companyId=" + senderId,
                  method: "get"
                })
                if (res.data.status == 200) {
                  roomIcon = '/companyImg/' + res.data.data.companyIcon
                  roomName = res.data.data.companyName
                }
              } else {
                roomIcon = '/appImg/cartoon' + senderType + '.png'
              }
              newMap.set(roomId, {
                roomIcon: roomIcon,
                unread: 0,
                roomName: roomName
              })
            }
            const curRoom = newMap.get(roomId)
            curRoom.message = content
            curRoom.unread = curRoom.unread + 1
            curRoom.senderType = senderType
            curRoom.senderId = senderId
            curRoom.sendTime = sendTime

            state.messageRooms = newMap
            
            state.dialogMessageType=0
            state.showMessageDialog = roomId
            state.messageDialogContent = curRoom.roomName+":"+content
            
            if (state.currentRoomId != null) {

              state.messageList.push({
                senderType: senderType,
                senderId: senderId,
                content: content
              })
            }

          } else if (jsonObject.type == "confirmOrder") {
            state.dialogMessageType=1
            state.showMessageDialog = jsonObject.orderId
            state.messageDialogContent = "您的订单商家已确认"
          } else if (jsonObject.type == "cancelOrder") {
            state.dialogMessageType=1
            state.showMessageDialog = jsonObject.orderId
            state.messageDialogContent = "您的订单已被取消"
          }
        };
        // 监听socket关闭信息
        state.socket.onclose = (e) => {
          console.log("socket已经关闭");

        };
      }
    },
    setUserInfo(state, payload) {
      state.userInfo = payload
    }
  },
  actions: {
    async getUserInfoByToken({ commit }) {
      let res = await request({
        url: "/user/api/getUserInfoByToken",
        method: "get",
      })
      if (res.data.status == 200) {
        const userInfo = res.data.data;
        userInfo.type = 0
        localStorage.setItem("userInfo", JSON.stringify(userInfo))
      }
    },
  },
  modules: {
  }
})
